<template>
   <div  class="w-100 calendario">
     <v-toolbar flat class="sub-toolbar">
      <!-- Esc salir -->
      <!--<img class="btn-footer-izq" src="@/assets/images/Btn-ESC.gif" v-show="showEventCreationDialog3" @click="showEventCreationDialog3=false">
      <v-btn class="primary-color back mr-auto" v-show="showEventCreationDialog3"><v-icon class="mr-2">arrow_back</v-icon>{{ $t("lang.comun.salir") }}</v-btn>-->
      <!-- Abrir horario tienda -->
      <!--<img class="btn-footer-der pointer"@click="showEventCreationDialog3=true" src="@/assets/images/Btn_F2.gif" @click="showEventCreationDialog3=true">-->
      <!-- Guardar Calendario laboral -->      
      <!-- <img class="btn-footer-der pointer" src="@/assets/images/Btn-FIN.gif" @click="createDiatrabajo()">
      <label class="txt-footer-der">{{ msj.grabarfestivo }}</label> -->
      <!-- Borrar Calendario laboral -->
      <!-- <img class="btn-footer-der pointer" src="@/assets/images/Btn-SUPR.gif" @click="deleteDiatrabajo()">
      <label class="txt-footer-der">{{ msj.borrarfestivo }}</label> -->
    </v-toolbar>
    <div id="calendario" class="pt-4 px-2 ">
      <!-- <b-row>
        <b-col sm="8">
          <h3>Calendario laboral {{year}}</h3>
        </b-col>
      </b-row> -->
      <!-- <b-row>
        <b-col sm="4">
           Calendarios 
          <select
            @keydown.33.capture.prevent.stop
            @keydown.34.capture.prevent.stop
            @keydown.35.capture.prevent.stop
            @keydown.pause="$refs.idesc.focus"
            ref="icalend"
            v-model="calenlabselect"
            class="form-control form-control-sm"
            @change="calendarioChange()">
            <option disabled value="0" selected="selected">Seleccione calendario</option>
            <option v-for="calenlab in calenlablist" :key="calenlab.mscalenlabid" :value="calenlab.mscalenlabid">
              {{ `(${calenlab.mscalenlabanho}) ` }} {{ calenlab.mscalenlabnombre }}
            </option>
          </select>
          <span class="col-underline">{{ $t("lang.mantenimiento.calenlab.calenasoc") }}</span>
           -->
          <!-- CORRECTO 
          <b-alert
            class="p-0"
            :show="dismissCountDownCorrect"
            variant="primary"
            @dismissed="dismissCountDownCorrect=0"
            @dismiss-count-down="countDownChangedCorrect">
            {{ $t("lang.personas.alerta.correcto") }}
          </b-alert>
          ERROR 
          <b-alert
            class="p-0"
            :show="dismissCountDownError"
            variant="danger"
            @dismissed="dismissCountDownError=0"
            @dismiss-count-down="countDownChangedError">
            {{ $t("lang.personas.alerta.error") }}
          </b-alert>
        </b-col>
      </b-row> -->
   
        <div  class=" d-flex py-5" v-if="calenlabselect != 0"> 
            <div v-for="mesArr in mesesArray" :key="mesArr.mesNum" :class="['calendario-mes', { 'selected': mesArr.mesNum == mes}]" @click="irMes(mesArr.mesNum)">{{ mesArr.mesNom }}</div>
        </div>
      <div class="d-flex align-center ">
        <div v-if="calenlabselect != 0" >
          <v-btn type="button" flat icon aria-label="Previous month" class="vuecal__arrow vuecal__arrow--prev" @click="restarMes()">
            <i class="angle" :alt="$t('lang.comun.anterior')"></i>
            &nbsp;</v-btn>
        </div>
        <div  v-if="calenlabselect != 0" class="d-flex align-center"> 
            <div class="titulo-mes">{{ month }} {{ year }}</div>
            <v-btn type="button" flat class="primary no-flex" @click="irHoy">HOY</v-btn>
        </div>
        <div v-if="calenlabselect != 0" class="no-flex">
          <v-btn type="button" flat icon aria-label="Next month " class="float-right vuecal__arrow vuecal__arrow--next" @click="sumarMes()">
            <i class="angle" 
          :alt="$t('lang.comun.siguiente')"></i>
          </v-btn>
        </div>
      </div>
      <div class="mt-15 valign-center w-100" v-if="calenlabselect != 0">
          <!-- Calendario -->
          <!-- <b-col sm="2" class="text-right">
            <img
                class="btn-generico"
                :src="require("@/assets/images/arrow-icon-left.png")"
                :alt="$t("lang.comun.anterior")"
                @click="restarMes()"
              />
          </b-col> -->
          <div md="10" sm="10" class="col-center col-xs-12">
            <div class="calendario-body mt-2 noselect">
              <div class="calendario-semana large">
                  <span class="calendario-dia-semana" v-for="day in days" :key="day">{{ day }}</span>
              </div>
              <div class="calendario-semana sort">
                  <span class="calendario-dia-semana" v-for="day in daysSort" :key="day">{{ day }}</span>
              </div>
              <div class="calendario-dias">
                <div class="calendario-dias-fila" v-for="semana in calendario" :key="semana.indiceSemana">
                  <div
                    class="calendario-dias-fila-celda-peq pointer"
                    v-for="dia in semana.diasSemana"
                    :key="dia.diaNumber"
                    :class="{ deshabilitado : dia.diaTipo === 0, findesemana: dia.diaTipo === 2, vacaciones: dia.diaTipo === 3, 
                    festivootros: dia.tipoFestivo === 4, festivolocal: dia.tipoFestivo === 3, festivoregional: dia.tipoFestivo ===2, festivonacional: dia.tipoFestivo ===1, hoy : dia.hoy }"
                    @click.stop="modificarCalendario(dia)"
                  >
                    <div class="calendario-dias-fila-celda-dia">
                      {{ dia.diaNumber }}
                      <div v-if="dia.descFestivo !=''" class="diafestivo">{{ dia.descFestivo }}</div>
                      <div class="ico-editar">
                        <img :src="require('@/assets/images/menu_ico.gif')"/>
                      </div>
                    </div>
                    <div v-if="dia.diaTipo !== 0" v-show="false" :ref="'dia' + dia.diaNumber" class="modal-body">
 
                        <div class="d-flex flex-column">
                          <div class="mt-2">
                          <input class="mr-2" type="radio" id="Nacional" value=1 v-model="diatrabajo.msdiatrabajotipo" @change="createDiatrabajo()">
                          <span class="checkmark" @click.prevent=""></span>
                          <label for="Nacional" @click.prevent="">Nacional</label>
                          </div>
                          <div>
                          <input class="mr-2 mt-2" type="radio" id="Regional" value=2 v-model="diatrabajo.msdiatrabajotipo" @change="createDiatrabajo()">
                          <span class="checkmark"  @click.prevent=""></span>
                          <label for="Regional"  @click.prevent="">Regional</label>
                          </div>
                          <div>
                          <input class="mr-2 mt-2" type="radio" id="Local" value=3 v-model="diatrabajo.msdiatrabajotipo" @change="createDiatrabajo()">
                          <span class="checkmark"  @click.prevent=""></span>
                          <label for="Local" @click.prevent="">Local</label>
                          </div>
                          <div>
                          <input class="mr-2 mt-2" type="radio" id="Otros" value=4 v-model="diatrabajo.msdiatrabajotipo" @change="createDiatrabajo()">
                          <span class="checkmark"  @click.prevent=""></span>
                          <label for="Otros" @click.prevent="">Otros</label>
                          </div>
                          <div>
                          <v-btn fab icon absolute small top right type="button" v-show="diatrabajo.msdiatrabajotipo !== 0" class="v-btn theme--light primary" @click="deleteDiatrabajo()">
                            <v-icon >delete</v-icon>
                          
                          </v-btn>
                          </div>
                        </div>
                 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <b-col sm="2">
           <img
                class="btn-generico"
                :src="require("@/assets/images/arrow-icon-right.png")"
                :alt="$t("lang.comun.siguiente")"
                @click="sumarMes()"
              />
          </b-col> -->
        </div>
        <div class=" d-flex my-3 ml-3" v-if="calenlabselect != 0">
       
          <div class="no-flex mr-3">
              <div class="cuadrado-20 festivonacional"></div><span>Festivo nacional</span>
          </div>
          <div class="no-flex mr-3">
              <div class="cuadrado-20 festivoregional"></div><span>Festivo regional</span>
          </div>
          <div class="no-flex mr-3">
              <div class="cuadrado-20 festivolocal"></div><span>Festivo local</span>
          </div>
          <div class="no-flex mr-3">
              <div class="cuadrado-20 festivootros"></div><span>Festivo otros</span>
          </div>
          <div ></div>
        </div>
        <!-- FIN. Calendario -->    
    </div>
        <!-- Footer de botones -->
   <!--  <div id="footer">
      Esc salir 
      <img class="btn-footer-izq" src="@/assets/images/Btn-ESC.gif" v-show="showEventCreationDialog3" @click="showEventCreationDialog3=true">
      <label class="txt-footer-izq" v-show="showEventCreationDialog3">{{ $t("lang.comun.salir") }}</label>
      --><!-- Abrir horario tienda
      <img class="btn-footer-der pointer" src="@/assets/images/Btn_F2.gif" @click="showEventCreationDialog3=true">
      <label class="txt-footer-der">Horario tienda</label> -->
      <!-- Guardar Calendario laboral -->      
      <!-- <img class="btn-footer-der pointer" src="@/assets/images/Btn-FIN.gif" @click="createDiatrabajo()">
      <label class="txt-footer-der">{{ msj.grabarfestivo }}</label> -->
      <!-- Borrar Calendario laboral -->
      <!-- <img class="btn-footer-der pointer" src="@/assets/images/Btn-SUPR.gif" @click="deleteDiatrabajo()">
      <label class="txt-footer-der">{{ msj.borrarfestivo }}</label> -->
       <!-- </div>
 FIN. Footer de botones -->
     <!--Modal Horari v-show="showEventCreationDialog3"o-->
    <!-- fin modal -->
    <!-- modal -->
  <!-- <transition name="modal">
    <div class="modal-mask" v-if="modal">
      <div class="modal-wrapper">
        <div class="modal-container peq">
          <div class="modal-close"> 
            <a href="javascript:" @click="modal=false">
                <i class="icon-cross"></i>
              </a>
          </div>
          <div class="modal-header">
            <slot name="header">
             <div class="pt-1" v-if="mostrarModificarDia">
              <b-row class="pt-2 pl-3 pr-3" v-if="calenlabselect != 0">
                <b-col sm="12">
                  {{ msdiatrabajodia }}
                </b-col>
              </b-row>
             </div>
            </slot>
          </div>

          <div class="modal-body">
            <b-row class="pt-2 pl-3 pr-3 mb-15" v-if="calenlabselect != 0">
               <b-col sm="6">
                  <input type="radio" id="Nacional" value=1 v-model="diatrabajo.msdiatrabajotipo">
                  <span class="checkmark"></span>
                  <label for="Nacional">Nacional</label>
                  <br>
                  <input type="radio" id="Regional" value=2 v-model="diatrabajo.msdiatrabajotipo">
                  <span class="checkmark"></span>
                  <label for="Regional">Regional</label>
                </b-col>
                <b-col sm="6">
                  <input type="radio" id="Local" value=3 v-model="diatrabajo.msdiatrabajotipo">
                  <span class="checkmark"></span>
                  <label for="Local">Local</label>
                  <br>
                  <input type="radio" id="Otros" value=4 v-model="diatrabajo.msdiatrabajotipo">
                  <span class="checkmark"></span>
                  <label for="Otros">Otros</label>
                </b-col>
            </b-row>
            <div class="modal-detalle-info ">
              <label size="sm" for="idesc">{{ leyenda.descripcion }}:</label>
              <textarea id="idesc" ref="idesc" rows="4" class="form-control" v-model="diatrabajo.msdiatrabajodesc"></textarea>
            </div>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <b-col sm="6">
                <b-button class="mt-3" block @click="deleteDiatrabajo(); modal=false">
                  {{ $t("lang.comun.borrar") }}
                </b-button>
              </b-col>
              <b-col sm="6">
                <b-button class="mt-3" variant="primary" block @click="createDiatrabajo();modal=false">
                  {{ $t("lang.comun.guardar") }}
                </b-button>
              </b-col>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition> -->
  <!-- fin modal -->
  </div>
</template>
<script>
import { CalenlabApiService } from '@/api/CalenlabApiService'
import { DiatrabajoApiService } from '@/api/DiatrabajoApiService'
import { Util } from '@/api/Util'

// import HorarioTienda from '@/views/HorarioTienda'

// Componentes
import Const from '@/util/Const'

const calenlabApiService = new CalenlabApiService()
const diatrabajoApiService = new DiatrabajoApiService()
const util = new Util()
const moment = require('moment')

export default {
  data () {
    return {
      dialog: false,
      today: moment(),
      dateContext: moment(),
      lang: sessionStorage.getItem('lang'),
      modal: false,
      vacacion: [],
      calendarioLaboral: [],
      showEventCreationDialog3: false,
      opuid: this.$store.getters.getOpuid,
      days: [
        this.$t('lang.calendario.lun'),
        this.$t('lang.calendario.mar'),
        this.$t('lang.calendario.mie'),
        this.$t('lang.calendario.jue'),
        this.$t('lang.calendario.vie'),
        this.$t('lang.calendario.sab'),
        this.$t('lang.calendario.dom')
      ],
      daysSort: [
          'L',
          'M',
          'X',
          'J',
          'V',
          'S',
          'D'
      ],
      mesesArray: [
        { mesNum: 1, mesNom: this.$t('lang.calendario.mes1') },
        { mesNum: 2, mesNom: this.$t('lang.calendario.mes2') },
        { mesNum: 3, mesNom: this.$t('lang.calendario.mes3') },
        { mesNum: 4, mesNom: this.$t('lang.calendario.mes4') },
        { mesNum: 5, mesNom: this.$t('lang.calendario.mes5') },
        { mesNum: 6, mesNom: this.$t('lang.calendario.mes6') },
        { mesNum: 7, mesNom: this.$t('lang.calendario.mes7') },
        { mesNum: 8, mesNom: this.$t('lang.calendario.mes8') },
        { mesNum: 9, mesNom: this.$t('lang.calendario.mes9') },
        { mesNum: 10, mesNom: this.$t('lang.calendario.mes10') },
        { mesNum: 11, mesNom: this.$t('lang.calendario.mes11') },
        { mesNum: 12, mesNom: this.$t('lang.calendario.mes12') }
      ],
      leyenda: {
        descripcion: this.$t('lang.comun.descripcion')
      },
      mostrarModificarDia: false,
      diatrabajo: {
        msdiatrabajoid: 0,
        msdiatrabajotipo: 0,
        msdiatrabajodesc: ''
      },
      msdiatrabajodia: '',
      msdiatrabajodescmaxchars: 256,
      // calenlablist: [],
      calenlabselect: 0,
      msj: {
        grabarfestivo: this.$t('lang.comun.grabarfestivo'),
        borrarfestivo: this.$t('lang.comun.borrarfestivo')
      },
    }
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number,
    clickGuardarCalenlab: Number,
    clickBorrarCalenlab: Number
  },
  // components: {
  //   'horario-tienda': HorarioTienda
  // },
  created () {
    this.init()
  },
  mounted () {
    this.cambioTitulo()
    this.reset()
    this.mountListenerTeclas()
    this.getAllCalenlabByOpUid()
  },
  watch: {
    personaParam: {
      handler (n, o) {
        if (n.mspersonaid !== o.mspersonaid) {
          this.reset(n)
        }
      },
      deep: true
    },
    year: {
      handler (n, o) {
        if (n !== o) {
          this.getAllCalenlabByOpUid()
          this.cambioTitulo()
          // this.findAllDiatrabajo()
          this.mostrarModificarDia = false
        }
      },
      deep: true
    },
    mes: {
      handler (n, o) {
        if (n !== o) {
          this.mostrarModificarDia = false
        }
      },
      deep: true
    },
    cambiotienda (value) {
      this.opuid = value;
      this.init()
      this.reset()
      this.mountListenerTeclas()
      this.getAllCalenlabByOpUid()
    }
  },
  methods: {
    init () {
      moment.locale('es')
      this.today = moment()
      this.dateContext = moment()
      // this.getVacacionByPersonaId()
      // if (sessionStorage.getItem('opUid')) {
      //   // Parseamos la persona almacenada en session
      //   this.opuid = sessionStorage.getItem('opUid')
      // }
      this.findAllDiatrabajo()
    },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">event</v-icon>`
      this.$store.state.titulo = "Calendario laboral " + this.year
    },
    calendarioChange () {
      this.findAllDiatrabajo()
    },
    mountListenerTeclas () {
      // Anhadimos el listener para guardar (Tecla FIN=35)
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 35) {
            this.createDiatrabajo()
        } else if (e.keyCode === 46) { // Supr
            this.deleteDiatrabajo()
        } else if (e.keyCode === 113) { // F2
            this.showEventCreationDialog3 = true
        } else if (e.keyCode === 27) { // ESC
            this.showEventCreationDialog3 = false
        }
      })
      document.getElementById("calendario").addEventListener('click', (e) => {
        this.cerrarFestivo()
      })
      this.isMountedDatos = true
    },
    cerrarFestivo (){
      for (let i = 1; i <= moment(this.dateContext).daysInMonth(); i++) {
          this.$refs['dia' + i][0].style="display:none;"
          this.$refs['dia' + i][0].classList.remove("add-festivo")
      }
    },
    reset () {
      this.today = moment()
      this.dateContext = moment()
    },
    sumarMes: function () {
      this.dateContext = moment(this.dateContext).add(1, 'month')
    },
    restarMes: function () {
      this.dateContext = moment(this.dateContext).subtract(1, 'month')
    },
    irMes: function (numMes) {
      this.dateContext = moment(this.dateContext).set('month', numMes - 1)
    },
    irHoy () {
       this.dateContext = moment(this.dateContext).set('month', moment().month())
    },
    findAllDiatrabajo () {
      if (this.calenlabselect > 0) {
        diatrabajoApiService.findAllDiatrabajo( { msdiatrabajocalenlabid: this.calenlabselect } )
          .then(data => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - findAllDiatrabajo', data.length, 'OK')
            this.calendarioLaboral = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - findAllDiatrabajo', error, 'ERROR')
          })
      }
    },
    checkDia: function (dia, mes, anho) {
      var diaObj = {
        diaNumber: null,
        diaStr: '',
        diaTipo: 0,
        msvacacionid: -1,
        tipoFestivo:0,
        descFestivo: ''
      }
      if (dia && mes && anho) {
        var fecha = moment(dia + '-' + mes + '-' + anho, 'DD-MMM-YYYY')
        diaObj.fecha = fecha
        var tipoFestAux = this.isFestivo(fecha)
        if (tipoFestAux[0] !==0 ) { // Comprobamos si es festivo
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 4
          diaObj.tipoFestivo = tipoFestAux[0]
          diaObj.descFestivo = tipoFestAux[1]
        } else if (moment(fecha).day() === 0) { // Fin de semana
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 2
        } else { // Todo lo demas
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 1
        }

        if (moment(fecha).isSame(new Date(), 'day')) {
          diaObj.hoy = true
        }
      }
      return diaObj
    },
    isFestivo (fecha) {
      if (this.calendarioLaboral.length > 0) {
        for (let i = 0; i < this.calendarioLaboral.length; i++) {
          const calendarioLaboralItem = this.calendarioLaboral[i]
          if (moment(fecha).isSame(calendarioLaboralItem.msdiatrabajofecha)) {
            if (calendarioLaboralItem.msdiatrabajotipo === 1 || calendarioLaboralItem.msdiatrabajotipo === 2 || calendarioLaboralItem.msdiatrabajotipo === 3 || calendarioLaboralItem.msdiatrabajotipo === 4) {
              return [calendarioLaboralItem.msdiatrabajotipo, calendarioLaboralItem.msdiatrabajodesc]
            }
          }
        }
        return [0,'']
      }
      else {
        return [0,'']
      }
    },
    modificarCalendario (dia) {
      if (this.permitido('MOBILESTORE.GESTIONTIENDA.CALENDARIO.CRUD')) {
        this.cerrarFestivo()
        this.$refs['dia' + dia.diaNumber][0].style="display:none;"
        this.$refs['dia' + dia.diaNumber][0].classList.add("add-festivo")
        if (dia.fecha != undefined) {
          // this.modal = true
          let fechaFormat = dia.fecha.format('YYYYMMDD')
          let encontrado = false

          // Buscamos el dia
          if (this.calendarioLaboral && this.calendarioLaboral.length > 0) {
            for (let i = 0; i < this.calendarioLaboral.length; i++) {
              const dia = this.calendarioLaboral[i];
              if (fechaFormat === dia.msdiatrabajofechastr) {
                this.diatrabajo.msdiatrabajotipo = dia.msdiatrabajotipo
                this.diatrabajo.msdiatrabajodesc = dia.msdiatrabajodesc
                this.diatrabajo.msdiatrabajoid = dia.msdiatrabajoid
                encontrado = true
              }
            }
          }

          if (!encontrado) {
            this.diatrabajo.msdiatrabajoid = 0
            this.diatrabajo.msdiatrabajotipo = 0
            this.diatrabajo.msdiatrabajodesc = ''
          }
          this.diatrabajo.msdiatrabajofecha = dia.fecha
          this.diatrabajo.msdiatrabajofechastr = fechaFormat

          this.msdiatrabajodia = dia.fecha.format('DD MMMM')

          this.mostrarModificarDia = true
        }
      }
    },
    deleteDiatrabajo () {
      if (this.diatrabajo.msdiatrabajoid !== 0) {
        calenlabApiService.deleteDiatrabajo(this.diatrabajo)
            .then(data => {
              // this.showCorrectAlert()
              util.mostrarEnConsola('PersonasTabMantCalenlab - deleteDiatrabajo', data.status, 'OK')
              this.findAllDiatrabajo()
              this.diatrabajo.msdiatrabajodesc = ''
              this.diatrabajo.msdiatrabajotipo = '0'
              this.cerrarFestivo()
            })
            .catch(error => {
              this.showErrorAlert(this.$t('lang.comun.error'))
              util.mostrarEnConsola('PersonasTabMantCalenlab - deleteDiatrabajo', error, 'ERROR')
              this.cerrarFestivo()
            })
      }
    },
    createDiatrabajo () {
      if (this.diatrabajo && this.isValidDescDim() && this.diatrabajo.msdiatrabajotipo !== 0 && this.calenlabselect > 0) {
        this.diatrabajo.msdiatrabajocalenlabid = this.calenlabselect
        
        switch (this.diatrabajo.msdiatrabajotipo) {
          case '1':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FNACIONAL
            break;
          case '2':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FREGIONAL
            break;
          case '3':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FLOCAL
            break;
          case '4':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FOTROS
            break;
          default:
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FOTROS
            break;
        }

        calenlabApiService.createDiatrabajo(this.diatrabajo)
            .then(data => {
              util.mostrarEnConsola('PersonasTabMantCalenlab - createDiatrabajo', data.status, 'OK')
              this.findAllDiatrabajo()
              this.cerrarFestivo()
            })
            .catch(error => {
              this.showErrorAlert(this.$t('lang.comun.error'))
              util.mostrarEnConsola('PersonasTabMantCalenlab - createDiatrabajo', error, 'ERROR')
              this.cerrarFestivo()
            })
      }
    },
    isValidDescDim: function () {
      if (this.diatrabajo) {
        if (util.isValidStringField(this.diatrabajo.msdiatrabajodesc, this.msdiatrabajodescmaxchars)) {
          return true
        } else {
          return false
        }
      }
    },
    getAllCalenlabByOpUid () {
      if (this.opuid) {
        calenlabApiService.getAllCalenlabByOp(this.opuid, this.year)
          .then(data => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - getAllCalenlabByOpUid', data.length, 'OK')
            this.calenlabselect = data[0].mscalenlabid
            this.findAllDiatrabajo()
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - getAllCalenlabByOpUid', error, 'ERROR')
            this.calenlabselect = 0
            this.findAllDiatrabajo()
          })
      }
    },
    showCorrectAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'info')
    },
    showErrorAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'error')
    },  
  },
  computed: {
    year: function () {
      return this.dateContext.format('Y')
    },
    mes: function () {
      return this.dateContext.format('MM')
    },
    month: function () {
      return this.dateContext.format('MMMM')
    },
    daysInMonth: function () {
      return this.dateContext.daysInMonth()
    },
    currentDate: function () {
      return this.dateContext.get('date')
    },
    firstDayOfMonth: function () {
      var firstDay = moment(this.dateContext).subtract((this.currentDate - 1), 'days')
      return firstDay.weekday()
    },
    initialDate: function () {
      return this.today.get('date')
    },
    initialMonth: function () {
      return this.today.format('MMMM')
    },
    initialYear: function () {
      return this.today.format('Y')
    },
    weekOfMonth: function () { // Semana con respecto al mes
      return this.dateContext.week() - moment(this.dateContext).startOf('month').week() + 1
    },
    numberOfWeeksOfMonth: function () {
      const dateFirst = moment(this.dateContext).date(1)
      const dateLast = moment(this.dateContext).date(this.dateContext.daysInMonth())
      const startWeek = dateFirst.isoWeek()
      const endWeek = dateLast.isoWeek()
      if (endWeek < startWeek) {
        return (Math.abs(dateFirst.isoWeeksInYear() - startWeek) + endWeek) + 1
      } else {
        return endWeek - startWeek + 1
      }
    },
    calendario: function () {
      const calendario = []
      var d = 1
      for (var semana = 0; semana < this.numberOfWeeksOfMonth; semana++) {
        // Creamos los días de la semana
        if (semana === 0) { // Primera semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var x = 0; x < this.firstDayOfMonth; x++) {
            semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
          }
          for (var l = this.firstDayOfMonth; l < 7; l++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        } else if (semana === this.numberOfWeeksOfMonth - 1) { // Ultima semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var i = 0; i < 7; i++) {
            if (d <= this.daysInMonth) {
              semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
              d++
            } else {
              semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
            }
          }
          calendario.push(semanaArray)
        } else { // Resto de semanas
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (let j = 0; j < 7; j++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        }
      }
      return calendario
    },
    cambiotienda () {
      return this.$store.getters.getOpuid;
    },
  }
}
</script>
